import React, { useEffect, useRef, useState } from "react";
import useApi from "../hook/useApi";
import { toast } from "react-toastify";
import Loader from "./Loader/Loader";
import { PAGE_TYPE } from "../utils/enum";
import { stripHtml } from "../utils/helper";
import JoditEditor from "jodit-react";
import { useNavigate } from "react-router-dom";

const TermsConditionLayer = () => {
  const { AsyncGetApiCall, AsyncPatchAPICall } = useApi();
  const [errors, setErrors] = useState({});
  const editor = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ title: "", content: "" });
  const navigate = useNavigate();

  const getData = async () => {
    setLoading(true);
    const url = "/cms/list";

    const query = {
      pageType: PAGE_TYPE.TERMS_CONDITIONS,
    };

    const result = await AsyncGetApiCall(url, query);
    console.log("API result:", result);
    if (result?.success) {
      setData(result?.data?.[0]);
    } else {
      toast.error(result.errors[0]);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const handleContentChange = (content) => {
    console.log("content", content)
    setData((prev) => ({ ...prev, content }));

    // Validate content on change
    const plainTextContent = stripHtml(content).trim();
    console.log("plainTextContent", plainTextContent)
    if (!plainTextContent) {
      setErrors((prev) => ({
        ...prev,
        content: "Content is required",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const plainTextContent = stripHtml(data.content).trim();

    if (!plainTextContent) {
      newErrors.content = "Content is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      toast.error("Please fill in all required fields");
      return;
    }

    setLoading(true);
    const result = await AsyncPatchAPICall(
      `/cms/update/${data?._id}`,
      {
        title: data?.title,
        content: data?.content,
        pageType: PAGE_TYPE.TERMS_CONDITIONS,
      }
    );
    console.log("result : ", result)
    if (result.success) {
      setData(result.data);
      toast.success("Content updated successfully");
    } else {
      toast.error(result.errors[0]);
    }
    setLoading(false);
  };

  const editorConfig = {
    placeholder: stripHtml(data.content).trim() ? "" : "Start typing...",
    askBeforePasteHTML: false, // Allow pasting without prompt
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_as_html", // Paste as HTML
    processPasteHTML: true,
    cleanHTML: {
      removeEmptyElements: false,
      fillEmptyParagraph: false,
    },
    allowAttributes: ["style", "class"],
    events: {
      afterPaste: (event) => {
        console.log("Paste event:", event);
        return true;
      },
      change: (newContent) => {
        console.log("Change event:", newContent); // Debug change event
      },
    },
    readonly: false, // Ensure editor is not readonly
    disablePlugins: [], // Avoid disabling key plugins
  };

  return (
    <>
      {loading && <Loader />}
      <div className="card basic-data-table radius-12 overflow-hidden">
        <div className="card-body p-0">
          <div className={errors.content ? "is-invalid" : ""}>
            <JoditEditor
              ref={editor}
              value={data?.content}
              config={editorConfig}
              onBlur={handleContentChange}
            />
            {errors.content && (
              <div className="invalid-feedback">{errors.content}</div>
            )}
          </div>
        </div>

        <div className="card-footer p-24 bg-base border border-bottom-0 border-end-0 border-start-0">
          <div className="d-flex align-items-center justify-content-center gap-3">
            <button
              type="button"
              className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-50 py-11 radius-8"
              onClick={() => {
                navigate("/dashboard");
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary border border-primary-600 text-md px-28 py-12 radius-8"
              onClick={handleSave}
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsConditionLayer;
